<template>
    <div>
        <v-dialog v-model="pmassessmentrecorddialog" max-width="800px">
            <template v-slot:activator="{ on }" v-if="!isAdvanceEdit">
                <!-- if isAdvanceEdit dont show this button -->
                <v-btn color="primary" dark class="mt-4 mb-3 ml-1" @click="newItem" v-on="on">+</v-btn>
            </template>
            <v-card>
                <v-card-title>
                    <span class="headline">
                        {{ isEdit ? $t('pmassementrecord.pmassessmentrecordreviewedit') : $t('pmassementrecord.pmassessmentrecordreviewnew') }}
                </span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>                                    
                            <v-col cols="9" sm="6" md="6" class="mt-n4">
                                <v-autocomplete
                                    outlined
                                    :label= "$t('performancereport.reviewexercisedescription')"
                                    type="text"
                                    :items="ReviewList"
                                    hide-selected
                                    :rules="[rules.required]"
                                    v-model="formData.reviewexerciseid"
                                    @change="changeReviewHandler(formData.reviewexerciseid)"
                                    dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="2" sm="6" md="6" class="mt-n4">
                                <v-text-field
                                    outlined
                                    background-color="#ffeab2"
                                    readonly
                                    :label= "$t('pmassementrecord.reviewexercisecode')"
                                    type="text"
                                    v-model="formData.reviewcode"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- <v-row v-if="this.parentObject.pmassecalmethodid == 1">  -->
                        <v-row v-if='this.parentObject.pmassecalmethodname == "Percentage"'> 
                            <!-- if calulation method==percentage, which is id 1 in pmasscalmethod table -->
                            <!-- then show this to let user input -->
                            <v-col cols="5" sm="5" md="5" class="mt-n8">
                                <v-text-field
                                    outlined
                                     :label= "$t('columns.percentage')"
                                    type="number"
                                    :rules="[rules.percentage,rules.required]"
                                    dense
                                    v-model="formData.percentage"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{errMsg}}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="closePmAssessmentRecordReviewInput">{{$t('button.cancel')}}</v-btn>
                    <v-btn color="green darken-1" text @click="savePmAssessmentRecordReviewInput">{{$t('button.save')}}</v-btn>
                </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- :headers="this.parentObject.tabHeader" -->
        <v-row>
            <v-col cols="12">
                <div style="width:100%;overflow-x:auto;">
                <v-data-table
                    :headers="filteredTabHeader"
                    :items="detailItem"
                    class="elavation-1"
                    fixed-header
                    :sort-by="['code']"
                >
                    <template v-slot:[`item.action`]="{ item }">
                        <v-icon
                            small
                            class="mr-2"
                            @click="modifyItemHandler(item)"
                        >
                            mdi-pen
                        </v-icon>
                        <v-icon
                            small
                            class="ml-3 mr-2"
                            @click="deleteItemHandler(item)"
                        >
                            mdi-delete
                        </v-icon>
                    </template>
                </v-data-table>
                </div>
            </v-col>
        </v-row>
        <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
        <div v-if="isConfirm">
            <app-confirm
                v-bind:parentObject="{
                messageConfirm: this.messageConfirm,
                isConfirm: this.isConfirm,
                }"
                v-on:confirm="deleteItemHandlerAction"
                v-on:cancelConfirm="isConfirm = !isConfirm"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";
import moment from 'moment';

export default {
    props: {
        parentObject: Object
    },

    computed: {
        filteredTabHeader() {
            return this.parentObject.tabHeader
                .filter(column => 
                    (this.isAdvanceEdit ? column.value !== 'action' : true) &&
                    // (this.parentObject.pmassecalmethodid !== 1 ? column.value !== 'percentage' : true)
                    (this.parentObject.pmassecalmethodname !== "Percentage" ? column.value !== 'percentage' : true)
                );
        }
    },

    components: {
        "app-error": ErrorDialog,
        "app-confirm": ConfirmDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                percentage: value => !(value < 0 || value > 100) || this.$t('reportsparam.valueonetohundred')
            },

            pmassessmentrecorddialog: false,
            detailItem: this.parentObject.detailItem,

            formData: {
                id: null,
                pmassessmentrecordid: this.parentObject.pmassessmentrecordid,
                reviewexerciseid: null,
                reviewcode:null,
                percentage: null,
                rectimestamp: null,
                action: 0,
                stamp: 0,
                updatedby: this.$store.getters.userId,
                userid: this.$store.getters.userId,
            },
            ReviewList: [],
            completedReviewExerciseItem: [],
            isEdit: this.parentObject.isEdit,
            isAdvanceEdit: this.parentObject.isAdvanceEdit,
            modify: false,
            isExisting: false,
            isErr: false,
            errMsg: '',
            isConfirm: false,
            messageConfirm:'',
            selectedItem: null,
        }
    },

    methods: {
        newItem() {
            this.isExisting = false;
            this.modify = false;
            this.resetSelections();
        },
        async loadCompletedReviewExercise() {
            const vm = this;

            if (!this.parentObject.startdate || !this.parentObject.enddate) {
                console.error("❌ Missing startDate or endDate in parentObject");
                return;
            }
            this.$store.dispatch("get", {
                // only completed review exercise and its start date/ end date fall within 
                // this assessment.startdate/ assessment.enddate
                url: `/reviewexercise/items/completed/all?startDate=${this.parentObject.startdate}&endDate=${this.parentObject.enddate}`
            })
            .then(function (res) {
                vm.completedReviewExerciseItem = res.data.rec;

                vm.ReviewList = []; // Clear before populating
                for (let i = 0; i < vm.completedReviewExerciseItem.length; i++) {
                    vm.ReviewList.push({//this data is from table <pmreviewexercise>
                        text: vm.completedReviewExerciseItem[i].description,
                        code: vm.completedReviewExerciseItem[i].reviewcode,
                        value: vm.completedReviewExerciseItem[i].id,
                    });
                }
            })
            .catch(function (err) {
                vm.errMsg = err;
                console.error("❌ Error loading completed review exercises:", err);
            });
        },

        changeReviewHandler(id) {
            let item = this.completedReviewExerciseItem.find(item => item.id == id);
            //item is from the table <pmreviewexercise>
            this.formData.reviewcode = item.reviewcode;
            this.formData.reviewexerciseid = item.id;
            this.formData.userid= this.$store.getters.userId;
        },

        modifyItemHandler(item) {
            this.isEdit = true;
            this.pmassessmentrecorddialog = true;
            this.formData = item;
        },

        deleteItemHandler(item) {
            this.messageConfirm = this.$t('pmassementrecord.reviewdeleteconfirm', { code: item.reviewcode });
            this.selectedItem = item;
            this.isConfirm=true;
        },

        deleteItemHandlerAction() {

            if (!this.selectedItem) {
                console.error(" No item selected for deletion!");
                return;
            }

            const vm = this;
            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                console.error(" No permission to delete");
                return false;
            }

            this.$store.dispatch('delete', {
                url: "/performanceassessmentrecordreview/" + vm.selectedItem.id
            })
            .then(() => {
                const index = vm.detailItem.findIndex(detail => detail.id === vm.selectedItem.id);
                if (index !== -1) {
                    vm.detailItem.splice(index, 1);
                }
                vm.selectedItem = null; // 🔹 Clear after deletion
            })
            .catch(err => {
                vm.errMsg = err;
            });

            this.isConfirm = false;  // 🔹 Close confirmation dialog
        },

        async savePmAssessmentRecordReviewInput() {
            try {
                if (this.isEdit) { // Edit
                    if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                        console.error("❌ No permission to edit");
                        return false;
                    }

                    const res = await this.$store.dispatch('put', {
                        url: "/performanceassessmentrecordreview/" + this.formData.id,
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {
                        // ✅ Fetch the latest updated record from backend
                        const updatedRes = await this.$store.dispatch('get', {
                            url: `/reviewexercise/${this.formData.reviewexerciseid}`
                        });

                        if (updatedRes.data && updatedRes.data.rec && updatedRes.data.rec.length > 0) {
                            const updatedRecord = {
                                ...this.formData, // Keep existing data
                                reviewcode: updatedRes.data.rec[0].reviewcode || "N/A",
                                reviewdesc: updatedRes.data.rec[0].description || "N/A",
                                startdate: updatedRes.data.rec[0].startdate
                                    ? moment(updatedRes.data.rec[0].startdate).format('YYYY-MM-DD')
                                    : null,
                                enddate: updatedRes.data.rec[0].enddate
                                    ? moment(updatedRes.data.rec[0].enddate).format('YYYY-MM-DD')
                                    : null
                            };

                            // 🔄 Ensure Vue reactivity by replacing the object
                            const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                            if (index !== -1) {
                                this.$set(this.detailItem, index, updatedRecord);
                            } else {
                                console.warn("⚠️ Record not found in detailItem.");
                            }
                        } else {
                            console.error("❌ Error fetching review details: No data received.");
                        }

                        this.pmassessmentrecorddialog = false;
                        this.isEdit = false;
                        this.resetSelections();
                    }
                } else { // Add
                    if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                        console.error("❌ No permission to add");
                        return false;
                    }

                    const res = await this.$store.dispatch('post', {
                        url: "/performanceassessmentrecordreview/create",
                        payload: this.formData
                    });

                    if (res.data.error) {
                        this.isErr = true;
                        this.errMsg = Array.isArray(res.data.error)
                            ? res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n')
                            : res.data.error;
                    } else {
                        const insertedRecord = res.data.result;

                        // ✅ Fetch additional review details
                        const reviewExerciseResponse = await this.$store.dispatch('get', {
                            url: `/reviewexercise/${insertedRecord.reviewexerciseid}`
                        });

                        if (reviewExerciseResponse.data && reviewExerciseResponse.data.rec.length > 0) {
                            insertedRecord.reviewcode = reviewExerciseResponse.data.rec[0].reviewcode;
                            insertedRecord.reviewdesc = reviewExerciseResponse.data.rec[0].description;
                            insertedRecord.startdate = moment(reviewExerciseResponse.data.rec[0].startdate).format('YYYY-MM-DD');
                            insertedRecord.enddate = moment(reviewExerciseResponse.data.rec[0].enddate).format('YYYY-MM-DD');
                        }

                        this.detailItem.push(insertedRecord);
                        this.pmassessmentrecorddialog = false;
                        this.resetSelections();
                    }
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                console.error("❌ Error in processing:", err);
            }
        },

        closePmAssessmentRecordReviewInput() {
            this.pmassessmentrecorddialog = false;
            this.isErr = false;
            this.isEdit = false;
            // reset the form fields
            this.resetSelections();
        },
                
        resetSelections() {
            this.formData = {
                id:null,
                pmassessmentrecordid: this.parentObject.pmassessmentrecordid,
                reviewexerciseid: null,
                percentage: null,
                rectimestamp: null,
                stamp: 0,
                userid: this.$store.getters.userId,

                pmassessmentrecorddialog: false,
         
            }
        },

    },

    async mounted() {
        try {
            await this.loadCompletedReviewExercise();
        } catch (err) {
            this.isErr = true;
            this.errMsg = err.message || "An error occurred while loading data";
            console.error("❌ Error in mounted:", err);
        }
    },

}
</script>